<template>
  <div :class="cn('inline-block', $attrs.class as ClassValue)" @click="openCsUrl">
    <slot>
      <CS_SVG class="size-6" />
    </slot>
  </div>

  <!-- <teleport to="body">
    <div v-if="isOpen" class="cs-url-overlay">
      <iframe ref="iframeRef" class="cs-url-iframe" :src="iframeSrc" title="Customer Service" />
    </div>
  </teleport> -->
</template>

<script setup lang="ts">
import { computed, onBeforeUnmount, onMounted, ref } from 'vue'
import { appConfigsApi } from '@/api/app'
import { useAppConfigStore } from '@/stores/appConfig'
import { cn, openCsUrl, toastify } from '@/utils'
import CS_SVG from '@/svg/CS.svg'
import type { ClassValue } from 'clsx'

const props = defineProps<{
  csUrl?: string
}>()

const appConfigStore = useAppConfigStore()

const iframeRef = ref<HTMLIFrameElement | null>(null)
const iframeSrc = ref('')
const isOpen = ref(false)

function closeCustomerService() {
  isOpen.value = false
  iframeSrc.value = ''
}

function handleMessage(event: MessageEvent) {
  if (!isOpen.value) {
    return
  }

  if (!iframeRef.value || event.source !== iframeRef.value.contentWindow) {
    return
  }

  const payload = event.data
  if (!payload || typeof payload !== 'object') {
    return
  }

  if ((payload as { type?: string }).type === 'CS_CLOSE') {
    closeCustomerService()
  }
}

onMounted(() => {
  window.addEventListener('message', handleMessage)
})

onBeforeUnmount(() => {
  window.removeEventListener('message', handleMessage)
})

defineExpose({
  // openCustomerService,
  closeCustomerService,
})
</script>

<style scoped lang="less">
.cs-url-overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;
  background: #fff;
}

.cs-url-iframe {
  width: 100%;
  height: 100%;
  border: none;
}
</style>
